import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { Seal } from '../brand/Seal';
import { useBrand } from '../../contexts/BrandContext';
interface CtaBandProps {
  title?: string;
  intro?: string;
}
export function CtaBand({
  title,
  intro
}: CtaBandProps) {
  const {
    brand,
    text
  } = useBrand();
  const heading = title ? text(title) : 'Start with one question.';
  const body = intro ? text(intro) : brand.copy.ctaIntro;
  return <section className="border-t border-ink/10 bg-cream-deep text-ink" data-id="element-358" data-mp="v0fqtbpletaa">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-359" data-mp="qzvs43pdfhm1">
        <div className="grid items-center gap-12 lg:grid-cols-[1.3fr_auto] lg:gap-20" data-id="element-360" data-mp="m35bnf9nmk03">
          <div data-id="element-361" data-mp="h3srx3e2xt1q">
            <h2 className="max-w-2xl font-serif text-4xl leading-[1.06] md:text-[3.25rem]" data-id="element-362" data-mp="h4awcnawbdkq">
              {heading}
            </h2>
            <p className="mt-6 max-w-xl leading-relaxed text-ink-soft" data-id="element-363" data-mp="2ge0vjdqahli6">{body}</p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-364" data-mp="2bhjx9qpdlqrd">
              <Button to="/start" data-id="element-365" data-mp="2p5ttjn70y7gi">
                Start with one question
                <ArrowRightIcon className="h-4 w-4" data-id="element-366" data-mp="2t7f7lbvaorsa" />
              </Button>
              <Button to="/symptoms" variant="secondary" data-id="element-367" data-mp="2t5c69voozc89">
                Or just use the decoder — it’s free
              </Button>
            </div>
          </div>
          <Seal className="hidden h-40 w-40 text-brick/70 lg:block" data-id="element-368" data-mp="2k7s5soynljyp" />
        </div>
      </div>
    </section>;
}